import React, { useEffect } from 'react';
import { useUser } from '../../context/UserContext';
import { useMembership } from '../../context/MembershipContext';
import { useTenant } from '../../context/TenantContext';

/**
 * Reloads tenant config after auth + membership are ready.
 * Preserves pre-login org selection — clearing happens only on explicit logout
 * or when the user opens the organization picker.
 */
export function TenantConfigReloader() {
  const { user, loading: userLoading, blockingTenantLogin } = useUser();
  const { loading: membershipLoading, resolveTenantId } = useMembership();
  const { tenantId, switchTenant } = useTenant();

  useEffect(() => {
    if (userLoading || membershipLoading || blockingTenantLogin || !user?.uid) return;

    const resolvedTenantId = resolveTenantId(tenantId);
    if (resolvedTenantId !== tenantId) {
      switchTenant(resolvedTenantId);
      return;
    }

    if (tenantId) {
      switchTenant(tenantId);
    }
  }, [
    user?.uid,
    userLoading,
    membershipLoading,
    blockingTenantLogin,
    tenantId,
    resolveTenantId,
    switchTenant,
  ]);

  return null;
}

export default TenantConfigReloader;
